import { AnswerFlagArea, SustainabilityArea } from '@app/src/types/resourceExplorer'
import { FlagOutlined } from '@mui/icons-material'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import ParkOutlinedIcon from '@mui/icons-material/ParkOutlined'
import type { SvgIconProps } from '@mui/material'
import React from 'react'

interface SustainabilityAreaIconProps extends SvgIconProps {
  area?: SustainabilityArea | typeof AnswerFlagArea
}

const iconMap: Record<string, React.ElementType> = {
  [SustainabilityArea.Environment]: ParkOutlinedIcon,
  [SustainabilityArea.Social]: GroupsOutlinedIcon,
  [SustainabilityArea.Governance]: AccountBalanceOutlinedIcon,
  [SustainabilityArea.SupplyChain]: AccountTreeOutlinedIcon,
  [AnswerFlagArea]: FlagOutlined,
}

const SustainabilityAreaIcon: React.FC<SustainabilityAreaIconProps> = ({ area, ...props }) => {
  const IconComponent = iconMap[area ?? AnswerFlagArea] ?? BlockOutlinedIcon

  return <IconComponent {...props} />
}

export default SustainabilityAreaIcon
